import React from 'react';
import MUIDataTableCustomStyle from '../MUIDataTableCustomStyle';
import { Vocabulary } from '../../Utils/Vocabulary';
import { ETableEditAction } from '../../Utils/Enums';

const SalesTable = () => {

  const salesColumn = [
    {
      label: `${Vocabulary?.name}`,
      name: "name",
      options: {
        sort: true,
      },
    },
    {
      label: `${Vocabulary.email}`,
      name: "email",
      options: {
        sort: false,
      },
    },

  ];
  return (
    <div>
      <MUIDataTableCustomStyle
        title='Vanzari'
        columns={salesColumn}
        onEditAction={ETableEditAction.REDIRECT}></MUIDataTableCustomStyle>
    </div>
  );
};

export default SalesTable;
